import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAppInstall} from '../../../apis/analysis/getAppInstall'

export const useQueryAppInstall = (limit: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getAppInstall(limit),
        queryFn: async () => {
            const {data} = await getAppInstall(limit)
            return data
        },
    })

    return {data, refetch}
}
